import moment from 'moment';

// Started to align the image to the center of the container in a different way from this date
export const newContainerAlignment = (date: string) =>
  moment(date).isAfter('2023-03-30', 'day');
